/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import { IBettingRules } from '@protocol/component'
// icon
import { ArrowIco } from '@shared/Icon/ArrowIcon'
// css
import {
  LightListWrap,
  TitleWrap,
} from '@styles/base.style'
import { BackBtn, Button } from '@styles/button.style'
import Chat from '@views/Popup/Chat'
import authStore from '@store/authStore'
import NavBar from '@views/Navbar'

const BettingRules: React.FC = () => {
  const { routerStore, globalStore, componentStore, chattingStore, logStore } = useRootStore()
  const { isChatEnabled } = chattingStore

  useOnMount(() => {
    componentStore.fetchBettingRules({})
  })

  const onClickNoticeDetail = (bettingRule: IBettingRules.BettingRule) => {
    componentStore.setSelectedBettingRule(bettingRule)
    globalStore.setVisibleBettingRulesDetail(true)
  }

  const bettingRules = componentStore.bettingRules

  let bettingRuleList
  if (bettingRules) {
    let count = 0
    bettingRuleList = bettingRules.map((bettingRule) => {
      const key = `BettingRules:list:${count}`
      const result = (<li key={key} className="bright-list--item fixed">
          <Button className="list-btn" onClick={() => onClickNoticeDetail(bettingRule)}>
            {/* ***************** 고정글일 경우에 추가되는 이미지 입니다. ***************** */}
            {bettingRule.isNotice === 1 && (<span className="main-tag">주요</span>)}
            <div className="list-info">
              <p className="tit">{bettingRule.title}</p>
            </div>
          </Button>
        </li>
      )
      count += 1
      return result
    })
  }

  return (
    <Fragment>
      {isMobile && (
        <TitleWrap className="title-wrap white">
          <BackBtn onClick={() => {
            logStore.writeButtonLog({ pageId: 'd030', buttonId: '001' }).catch(console.error)
            routerStore.goBack()
          }}>
            <ArrowIco/>
          </BackBtn>
        </TitleWrap>
      )}
      <LightListWrap>
        <ul className="bright-list">
          {bettingRuleList}
        </ul>
      </LightListWrap>
      {isChatEnabled && !authStore.isSpecificClubMember && isMobile && <Chat key="BettingRules:Chat"/>}
      {isMobile && <NavBar key="BettingRules:NavBar"/>}
    </Fragment>
  )
}

export default observer(BettingRules)
